import { isStatsHudVisible } from '../services/statsHudService';

/**
 * FPS + last localization-confidence readout. Originally always-visible
 * (not gated behind the debug-panel toggle); now shows/hides per the
 * persisted "📶 VPS/FPS" preference in the 🐞 debug panel (default: OFF,
 * per 2026-07-18 user request — a debug-oriented readout, off until
 * someone explicitly turns it on). Confidence is assumed to be a 0-1
 * fraction — matches this
 * codebase's own existing use of `confidenceThreshold: 0.5` when
 * configuring the WebXR SDK (see multisetClient.ts), and both
 * `ILocalizeResponse.confidence` (WebXR SDK) and `MapQueryResult.confidence`
 * (REST, camera mode) come from the same MultiSet backend, so the same
 * convention applies to both.
 */
export class StatsHud {
  readonly el: HTMLDivElement;
  private fps = 0;
  private confidence: number | null = null;

  constructor() {
    this.el = document.createElement('div');
    this.el.className = 'stats-readout';
    this.el.classList.toggle('hidden', !isStatsHudVisible());
    this.render();
  }

  setVisible(visible: boolean): void {
    this.el.classList.toggle('hidden', !visible);
  }

  setFps(fps: number): void {
    this.fps = fps;
    this.render();
  }

  setConfidence(confidence: number | null): void {
    this.confidence = confidence;
    this.render();
  }

  private render(): void {
    const fpsText = `${Math.round(this.fps)} FPS`;
    const confText = this.confidence === null ? '—' : `${Math.round(Math.min(this.confidence, 1) * 100)}%`;
    this.el.textContent = `${fpsText} · Localization ${confText}`;
  }
}
